// --------------------------------------------------------------------------
// #34 – Membership form
//     - handles entering and validating addresses for all address fields
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();
var debounce = require('../utilities/debounce');

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');
require('../plugins/expressive.annotations.validate');

module.exports = function (options) {
    var context = options.context;
    var subscribeScrollToElement;
    var subscribeUpdateAddress;

    // Store member and different billing address for switching between same and different address toggle
    var memberAddress = {
        address: '',
        town: '',
        county: '',
        postcode: '',
        country: ''
    };

    var differentBillingAddress = {
        address: '',
        town: '',
        county: '',
        postcode: '',
        country: ''
    };

    var addressHTMLFieldGroupNonEditableAddress = '<div class="field-group"><div class="non-edittable-address" aria-live="alert"></div></div>';
    var addressHTMLEditAddressButton = '<button class="edit-selected-address" data-binding="edit-selected-address-button" type="button">Edit</button>';

    /**
    * Updates the hidden address fields passed to Authorize.Net
    */
    function updateBillingAddress(line1, line2, line3, town, county, postcode, country) {
        var hiddenAddress = $('#x_address');
        var hiddenTown = $('#x_city');
        var hiddenCounty = $('#x_state');
        var hiddenPostcode = $('#x_zip');
        var hiddenCountry = $('#x_country');

        if (hiddenAddress.length > 0) {
            var address = line1;
            if (line2 !== '') {
                address += ', ' + line2;
            }
            if (line3 !== '') {
                address += ', ' + line3;
            }

            if (county === '') {
                county = town;
            }

            hiddenAddress.val(address);
            hiddenTown.val(town);
            hiddenCounty.val(county);
            hiddenPostcode.val(postcode);
            hiddenCountry.val(country);
        }
    }

    // update store for different address
    function updateHiddenBillingAddress(line1, line2, line3, town, county, postcode, country) {

        var address = line1;
        if (line2 !== '') {
            address += ', ' + line2;
        }
        if (line3 !== '') {
            address += ', ' + line3;
        }

        if (county === '') {
            county = town;
        }

        differentBillingAddress.address = address;
        differentBillingAddress.town = town;
        differentBillingAddress.county = county;
        differentBillingAddress.postcode = postcode;
        differentBillingAddress.country = country;
    }

    // Update store for member address
    function updateHiddenMemberAddress(line1, line2, line3, town, county, postcode, country) {

        var address = line1;
        if (line2 !== '') {
            address += ', ' + line2;
        }
        if (line3 !== '') {
            address += ', ' + line3;
        }

        if (county === '') {
            county = town;
        }

        memberAddress.address = address;
        memberAddress.town = town;
        memberAddress.county = county;
        memberAddress.postcode = postcode;
        memberAddress.country = country;
    }

    // Update hidden address fields on different/same address toggle
    function switchHiddenBillingAddress(address) {

        var hiddenAddress = $('#x_address');
        var hiddenTown = $('#x_city');
        var hiddenCounty = $('#x_state');
        var hiddenPostcode = $('#x_zip');
        var hiddenCountry = $('#x_country');

        hiddenAddress.val(address.address);
        hiddenTown.val(address.town);
        hiddenCounty.val(address.county);
        hiddenPostcode.val(address.postcode);
        hiddenCountry.val(address.country);
    }

    function updateSchoolAddress() {
        if ($('[data-binding="school-address"]').length) {
            $('[data-binding="school-address"]').trigger('address-updated');
        }
    }

    /**
    * Returns a pubsub subscribe function for listening for when an address field is updated
    * The object passed may contain an array of address parts as simple strings (from the selection following a post-code look-up,
    * or an array of form fields (from the manual entry).  The 'fromSelection' boolean field is used to distinguish.
    * @return { pubsub.subscribe } a pubsub subscribe function
    */
    function subscribeUpdateAddressFn() {
        return events.subscribe('update-address-fields', function (obj) {

            var address = obj.address;

            if (!obj.fromSelection) {
                obj.addressWrapper.find('.non-edittable-address').empty();

                $.each(address, function (index, value) {

                    obj.addressWrapper.find('.non-edittable-address').append('<div class="address-row">' + $(value).val() + '</div>', addressHTMLEditAddressButton);
                    obj.addressWrapper.find('.address-part-' + (index + 1)).val($(value).val());
                });
                updateSchoolAddress();
            }

            var addressLine1 = obj.fromSelection ? address[0] : address[0].value;
            var addressLine2 = obj.fromSelection ? address[1] : address[1].value;
            var addressLine3 = obj.fromSelection ? address[2] : address[2].value;
            var addressTown = obj.fromSelection ? address[3] : address[3].value;
            var addressCounty = obj.fromSelection ? address[4] : address[4].value;
            var addressPostcode = obj.fromSelection ? address[5] : address[5].value;
            var addressCountry = obj.fromSelection ? address[6] : address[6].value;

            if ($('#AccountPaymentUseSameBillingAddress').is(':checked')) {
                // Same address for member and billing, address lookup is for member as different address lookup will be hidden
                updateHiddenMemberAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
                updateBillingAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
            } else if ($('#AccountPaymentUseDifferentBillingAddress').is(':checked') && obj.addressWrapper.data('binding') === 'address-step-3') {
                // Differen address for billing and address lookup is for different address
                updateHiddenBillingAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
                updateBillingAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
            } else if ($('#AccountPaymentUseDifferentBillingAddress').is(':checked') && obj.addressWrapper.data('binding') !== 'address-step-3') {
                // Different address for billing but address lookup is for member
                updateHiddenMemberAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
            } else {
                updateHiddenMemberAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
                updateHiddenBillingAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
                updateBillingAddress(addressLine1, addressLine2, addressLine3, addressTown, addressCounty, addressPostcode, addressCountry);
            }
        });
    }

    function subscribeScrollToElementFn() {
        return events.subscribe('scroll-to-element', function (obj) {
            $('html, body').animate({
                scrollTop: obj.offsetTop
            }, 500);
        });
    }

    function init() {

        var editAddressFields = context.find('[data-binding="edit-address-fields"]');
        editAddressFields.before(addressHTMLFieldGroupNonEditableAddress);
        context.find('.non-edittable-address').parent().hide();

        subscribeScrollToElement = subscribeScrollToElementFn();
        subscribeUpdateAddress = subscribeUpdateAddressFn();

        // Display all address fields and scroll to
        context.on('click', '[data-binding="outside-uk-button"], [data-binding="enter-address-manually"]', function (e) {
            e.preventDefault();

            var editAddressFields = context.find('[data-binding="edit-address-fields"]');

            editAddressFields.slideDown(function () {
                var offsetTop = editAddressFields.offset().top;
                events.publish('scroll-to-element', {
                    offsetTop: offsetTop
                });
            });
        });

        // look up address button click handler
        context.on('click', '[data-binding="find-address-button"]', function (e) {
            e.preventDefault();
            var contextAddress = $(this).closest('.address-lookup');
            var addressLoading = contextAddress.find('.address-loading');
            var form = $('[data-behavior~="form-multiple-address"]').find('form');
            var postcodeField = contextAddress.find('[data-binding="postcode-lookup-input-field"]');
            var postcodeFieldValid = contextAddress.validate().element(postcodeField);
            var errorMessage = postcodeField.data('error-message');

            addressLoading.show();

            if (postcodeFieldValid) {

                if (postcodeField.val() === '') {
                    var errorSpan = $(this).siblings('.inline').find('span');
                    errorSpan.removeClass('field-validation-valid').addClass('field-validation-error').text(errorMessage);
                    events.publish('scroll-to-error');
                    addressLoading.hide();
                } else {
                    $.ajax({
                        data: form.serialize() + '&' + $(this).attr('name') + '=',
                        type: form.attr('method'),
                        url: form.attr('action')
                    }).done(function (data) {
                        var editAddressFields;
                        contextAddress.empty().append(data);
                        editAddressFields = contextAddress.find('[data-binding="edit-address-fields"]');
                        editAddressFields.before(addressHTMLFieldGroupNonEditableAddress);
                        contextAddress.find('.non-edittable-address').parent().hide();
                        $.validator.unobtrusive.parse(form);
                        addressLoading.hide();
                    });
                }
            } else {
                if (postcodeField.val() === '') {
                    $(this).siblings('span').removeClass('field-validation-valid').addClass('field-validation-error').text(errorMessage);
                }

                events.publish('scroll-to-error');
            }
        });

        // edit address display
        context.on('click', '[data-binding="edit-selected-address-button"]', function (e) {
            e.preventDefault();
            var contextAddress = $(this).closest('.address-lookup');

            contextAddress.find('[data-binding="edit-address-fields"]').slideDown();
        });

        // put full address in place
        context.on('change', '[data-binding="address-select-dropdown"]', function (e) {
            e.preventDefault();
            var contextAddress = $(this).closest('.address-lookup');

            var fullAddress = $(this).find(':selected').data('fullAddress');
            fullAddress = fullAddress.split(';');

            contextAddress.find('.non-edittable-address').empty();

            $.each(fullAddress, function (index, item) {
                contextAddress.find('.non-edittable-address').append('<div class="addres-row">' + item + '</div>');
                contextAddress.find('.address-part-' + (index + 1)).val(item).change();
            });

            contextAddress.find('.non-edittable-address').parent().show();

            events.publish('update-address-fields', {
                address: contextAddress.find('[data-binding*="address-part"]'),
                addressWrapper: contextAddress
            });
        });

        context.on('keyup', '[data-binding="address-part-street-address"], [data-binding="address-part-town"], [data-binding="address-part-county"], [data-binding="address-part-postcode"]', debounce(function () {
            var contextAddress = $(this).closest('.address-lookup');
            events.publish('update-address-fields', {
                address: contextAddress.find('[data-binding*="address-part"]'),
                addressWrapper: contextAddress
            });
        }, 2000));

        context.on('change', '[data-binding="address-part-country"]', function () {
            var contextAddress = $(this).closest('.address-lookup');
            events.publish('update-address-fields', {
                address: contextAddress.find('[data-binding*="address-part"]'),
                addressWrapper: contextAddress
            });
        });

        context.on('change', '[data-binding="address-select-dropdown"]', function () {
            var contextAddress = $(this).closest('.address-lookup');
            var addressParts = contextAddress.find('option:selected', $(this)).attr('data-full-address').split(';');

            addressParts.push('United Kingdom');

            events.publish('update-address-fields', {
                address: addressParts,
                fromSelection: true,
                addressWrapper: contextAddress
            });
        });

        context.on('change', '[data-binding~="same-or-different-billing-address"]', function () {
            var type = $(this).data('binding').split(' ')[1];
            var parentFieldGroup = $(this).parents('.field-group');
            var addressLookup = parentFieldGroup.siblings('.address-lookup');

            if (type === 'different-address') {
                switchHiddenBillingAddress(differentBillingAddress);
                addressLookup.show();
            } else {
                addressLookup.hide();
                switchHiddenBillingAddress(memberAddress);
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/form-multiple-address.js
// module id = 249
// module chunks = 0